import React from 'react';
import { Image as ImageType } from '../../../commonTypes/image';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { GridItemProps } from '../../Grid';
import FooterCompliance from '../FooterCompliance';
import FooterNavBar, { FooterNavBarProps } from '../FooterNavBar';
import Section, { CustomisableFooterSection } from '../Section';
import useNavKeyboardControl from '../useNavKeyboardControl';
import { FooterWrapper, StyledGrid } from './styles';

export type CustomisableFooterProps = {
  sections?: CustomisableFooterSection[];
  footerCompliance: {
    compliance: string;
    logo?: ImageType;
  };
  footerNavBar: FooterNavBarProps;
  enableKeyboardNavigation?: boolean;
} & ComponentProps;

const generalGridItemProps: GridItemProps = {
  desktop: 3,
  tabletLandscape: 6,
  tabletPortrait: 4,
  mobile: 4,
};

const CustomisableFooter: React.FC<CustomisableFooterProps> = ({
  sections,
  footerCompliance: { compliance, logo },
  footerNavBar,
  enableKeyboardNavigation,
  ...props
}) => {
  const linksSectionRef = useNavKeyboardControl<HTMLDivElement>();
  const complianceGridItemProps: GridItemProps = {
    desktop: logo ? 9 : 12,
    tabletLandscape: logo ? 9 : 12,
    tabletPortrait: logo ? 5 : 8,
    mobile: 4,
  };

  return (
    <footer {...componentProps(props)}>
      <FooterWrapper>
        {sections && (
          <StyledGrid
            alignLeft
            ref={enableKeyboardNavigation ? linksSectionRef : undefined}>
            {sections.slice(0, 4).map((section) => (
              <Section
                section={section}
                gridItemProps={section.customGridItemProps ?? generalGridItemProps}
                key={section.title}
              />
            ))}
          </StyledGrid>
        )}
        {compliance && (
          <FooterCompliance {...{ compliance, logo, complianceGridItemProps }} />
        )}

        <FooterNavBar links={footerNavBar.links} />
      </FooterWrapper>
    </footer>
  );
};

export default applyComponentTheme(CustomisableFooter, 'CustomisableFooter');
